import AuthenticationLayout from 'components/AuthLayout';
import Button from 'components/Button';
import Error from 'components/form/Error';
import { FlexColumn } from 'components/form/generic';
import Info from 'components/form/Info';
import Textarea from 'components/form/Inputs/Textarea';
import Space from 'components/Space';
import { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import useSWR, { mutate } from 'swr';
import User from 'types/User';
import privateAPI from 'utils/privateAxiosInstance';

const Form = styled.form`
  display: flex;
  flex-direction: column;

  button {
    margin-left: auto;
    margin-right: auto;
    margin-top: 3rem;
    margin-bottom: 4rem;
    padding: 0.7rem 1.1rem;
  }
`;

const Subtitle = styled.p`
  font-size: 0.9rem;
  font-weight: 400;
  max-width: 60rem;
  color: var(--gray-500);
  i {
    font-size: 0.9rem;
  }
`;

const Profile: FC = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [presentation, setPresentation] = useState<string>('');
  const handleChange: React.ChangeEventHandler<HTMLTextAreaElement> = (e) => {
    setPresentation(e.target.value);
  };

  const { data } = useSWR<User>('/auth/detailed-profile');
  useEffect(() => {
    data && setPresentation(data.presentation || '');
  }, [data]);

  const handleSubmit: React.FormEventHandler = (e) => {
    e.preventDefault();

    // Vérification : si le champ est vide ou ne contient que des espaces
    if (!presentation.trim()) {
      setError(true);
      return; // On arrête l'exécution ici, l'API ne sera pas appelée
    }

    setLoading(true);
    setError(false);
    privateAPI
      .post('/auth/edit-presentation', { presentation })
      .then(() => {
        mutate('/auth/profile');
        navigate('/mentee/sign-chart');
      })
      .catch(() => {
        setError(true);
      })
      .finally(() => setLoading(false));
  };
  

  return (
    <AuthenticationLayout
      backTo="/mentee/fill-form"
      title="Parlez-nous de vous (2/3)"
      subtitle=""
      src_image="/logo_institut_mentorat.png"
    >
      <Space height={1.5} />
      <Form onSubmit={handleSubmit}>
        <FlexColumn gap={1}>
          <Info style={{ width: '100%' }}>
            Ce champ pourra être vu par votre mentor et l'équipe mentorat.
          </Info>
          <Subtitle>
            Utilisez le champ suivant pour vous présenter. Vous pouvez décrire
            vos projets d'études ou professionnels, partager vos passions
            et nous dire plus à propos de ce que vous attendez du mentorat.
            <br />
            Ces informations nous permettront d'en savoir davantage sur votre
            parcours pour vous mettre en contact avec le mentor
            au profil le plus pertinent, dans la mesure du possible.
            <br />
            Vous aurez toujours la possibilité de modifier ces informations
            depuis vos paramètres utilisateur.
           <br />
            <i style={{ color: 'red' }}>Ce champ est obligatoire.</i>
          </Subtitle>
          <Subtitle></Subtitle>
          {error && <Error>Une erreur est survenue.</Error>}
          <Textarea
            rows={15}
            characterLimit={1500}
            value={presentation}
            onChange={handleChange}
            noEnterFireSubmit
          />
        </FlexColumn>
        <Button color="primary" loading={loading} disabled={!presentation.trim()}>
          Enregistrer
        </Button>
        
      </Form>
    </AuthenticationLayout>
  );
};

export default Profile;
